import api from '@/lib/axios'

// ============================================================================
//  attendance-enriched.api.ts — Couche API Pointage Enrichi (M9)
// ============================================================================

export interface AttendancePhoto {
  id: string; attendanceId: string; type: string; photoUrl: string
  latitude?: any; longitude?: any; isValidated: boolean; createdAt: string
  attendance?: {
    id: string; date: string; status: string
    employee?: { id: string; user: { firstName: string; lastName: string } }
  }
}

export interface AttendanceSite {
  id: string; entityId: string; name: string; address?: string | null
  latitude: any; longitude: any; radiusMeters: number
  qrCode: string; nfcTag?: string | null; isActive: boolean
  createdAt: string
}

export interface AttEnrichedStats {
  totalSites: number; activeSites: number; todayPhotos: number
  unvalidatedPhotos: number; todayAttendances: number
}

export interface QrClockResult {
  attendance: any; site: { id: string; name: string }
  distance: number; action: string
}

export interface TeamClockResult {
  total: number; success: number
  results: { employeeId: string; action: string; success: boolean; error?: string }[]
}

const BASE = '/attendance-enriched'
// FIX: TransformInterceptor wraps responses in { success, data, timestamp }
const res = <T>(r: any): T => r.data?.data ?? r.data

export const attendanceEnrichedApi = {
  // Stats
  stats: () => api.get<AttEnrichedStats>(`${BASE}/stats`).then(res),

  // Photos
  photos:        (q?: any) => api.get<{ data: AttendancePhoto[]; meta: any }>(`${BASE}/photos`, { params: q }).then(res),
  addPhoto:      (d: any) => api.post<AttendancePhoto>(`${BASE}/photos`, d).then(res),
  validatePhoto: (id: string, isValidated: boolean) => api.patch(`${BASE}/photos/${id}/validate`, { isValidated }).then(res),

  // Sites
  sites:        (q?: any) => api.get<{ data: AttendanceSite[]; meta: any }>(`${BASE}/sites`, { params: q }).then(res),
  site:         (id: string) => api.get<AttendanceSite>(`${BASE}/sites/${id}`).then(res),
  createSite:   (d: any) => api.post<AttendanceSite>(`${BASE}/sites`, d).then(res),
  updateSite:   (id: string, d: any) => api.patch<AttendanceSite>(`${BASE}/sites/${id}`, d).then(res),
  deleteSite:   (id: string) => api.delete(`${BASE}/sites/${id}`).then(res),
  regenerateQr: (id: string) => api.post<AttendanceSite>(`${BASE}/sites/${id}/regenerate-qr`).then(res),

  // QR Clock
  qrClock: (d: { qrCode: string; latitude: number; longitude: number; photoUrl?: string }) =>
    api.post<QrClockResult>(`${BASE}/qr-clock`, d).then(res),

  // Team Clock
  teamClock: (d: { employeeIds: string[]; type: string; latitude?: number; longitude?: number }) =>
    api.post<TeamClockResult>(`${BASE}/team-clock`, d).then(res),
}
